import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ISavedSearchWebhook } from "../../types/webhook";
import { savedSearchWebhooksQueryKeys } from "../key-factory/factory";

export default function useGetSavedSearchWebhooks(): UseQueryResult<ISavedSearchWebhook[]> {
    return useQuery({
        queryKey: savedSearchWebhooksQueryKeys.list(),
        refetchOnMount: "always",
        gcTime: 0,
        queryFn({ signal }) {
            return salesApiService.management.getSavedSearchWebhooks({ cancellation: signal });
        },
    });
}
